module.exports = __webpack_public_path__ + "static/media/viadipapa.91831ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/viadipapa.png
// module id = 691
// module chunks = 0